import makeStyles from "@mui/styles/makeStyles";
import { styled, Grid, CircularProgress } from "@mui/material";

export const GridItemForm = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  padding: "47px 24px 0 24px",
  [theme.breakpoints.down("lg")]: {
    padding: "40px 40px 0 40px",
    width: "100%",
  },
}));

export const Logo = styled("img")(() => ({
  width: "180px",
}));

export const CircularProgressStyled = styled(CircularProgress)(() => ({
  width: "100% !important",
  height: "100% !important",
  color: "#308CDB",
}));

const styles = makeStyles(() => ({
  approvingMessage: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "16px",
    color: "#9CA6AF",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: "75px",
    width: "75px",
  },
}));

export default styles;
